<template>
  <el-row class="container_self">
    <h3>产品管理</h3>
    <el-row class="table_parent">
      <el-table :data="tableData" v-loading="loading"  style="width: 100%">
        <el-table-column label="ID" width="50" align="center" prop="id"></el-table-column>
        <el-table-column label="UUID" align="center" prop="uuid"></el-table-column>
        <el-table-column label="标题" align="center" prop="title"></el-table-column>
        <el-table-column label="原价"  width="80" align="center" prop="originalPrice"></el-table-column>
        <el-table-column label="现价"  width="80" align="center" prop="currentPrice"></el-table-column>
        <el-table-column label="首次优惠"  width="80" align="center" prop="firstDiscount"></el-table-column>
        <el-table-column label="套餐类型"  width="80" align="center">
          <template slot-scope="scope">
              <span v-if="scope.row.planType === 1">周卡</span>
              <span v-if="scope.row.planType === 2">月卡</span>
              <span v-if="scope.row.planType === 3">年卡</span>
              <span v-if="scope.row.planType === 4">一日卡</span>
              <span v-if="!scope.row.planType">金币</span>
          </template>
        </el-table-column>
        <el-table-column label="是否自动续费"  width="120"  align="center">
          <template slot-scope="scope">
              <span v-if="scope.row.autoRenew === 1">是</span>
              <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="数量"  width="80"  align="center" prop="quantity"></el-table-column>
        <el-table-column label="赠送数量"  width="80"  align="center" prop="giftQuantity"></el-table-column>
        <el-table-column label="商品状态"  width="80" align="center">
          <template slot-scope="scope">
              <span v-if="scope.row.status === 1">在售</span>
              <span v-if="scope.row.status === 2">下架</span>
              <span v-if="scope.row.status === 3">删除</span>
          </template>
        </el-table-column>
        <el-table-column label="商品排序"   width="80"  align="center" prop="sorted"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="handleEdit(scope.row)">更新</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog title="更新产品" :visible="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="form" size="mini" ref="form" label-width="120px">
        <!-- <el-form-item label="ID">
          <el-input v-model="form.id" disabled></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="UUID">
          <el-input v-model="form.uuid" disabled></el-input>
        </el-form-item> -->
        <el-form-item label="标题">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="原价">
          <el-input v-model="form.originalPrice"></el-input>
        </el-form-item>
        <el-form-item label="现价">
          <el-input v-model="form.currentPrice"></el-input>
        </el-form-item>
        <el-form-item label="首次优惠">
          <el-input v-model="form.firstDiscount"></el-input>
        </el-form-item>
        <el-form-item label="套餐类型">
          <el-select v-model="form.planType">
            <el-option label="周卡" :value="1"></el-option>
            <el-option label="月卡" :value="2"></el-option>
            <el-option label="年卡" :value="3"></el-option>
            <el-option label="一日卡" :value="4"></el-option>
            <el-option label="金币" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否自动续费">
          <el-switch v-model="form.autoRenew"></el-switch>
        </el-form-item> -->
        <el-form-item label="数量">
          <el-input v-model="form.quantity"></el-input>
        </el-form-item>
        <el-form-item label="赠送数量">
          <el-input v-model="form.giftQuantity"></el-input>
        </el-form-item>
        <el-form-item label="商品状态">
          <el-select v-model="form.status">
            <el-option label="在售" :value="1"></el-option>
            <el-option label="下架" :value="2"></el-option>
            <el-option label="删除" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品排序">
          <el-input v-model="form.sorted"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      tableData: [],
      dialogVisible:false,
      form: {
        id: "",
        uuid: "",
        title: "",
        originalPrice: "",
        currentPrice: "",
        firstDiscount: "",
        planType: "",
        autoRenew: "",
        quantity: "",
        giftQuantity: "",
        status: "",
        sorted: "",
      },
      loading:false,
    };
  },
  methods: {
   async getProductList() {
      this.loading=true;
      await axiosGet("/api/product/list").then((res) => {
        if (res.code == 0) {
          this.tableData = res.data;
        }
      });
      this.loading=false;
    },
    handleClose(){
      this.dialogVisible = false;
    },
    handleSubmit() {
      axiosPost('/api/product/update',this.form,'JSON').then(res=>{
        if(res.code==0){
          this.$message.success('更新成功');
          this.dialogVisible = false;
          this.getProductList();
        }
      })
    },
    handleEdit(row) {
      console.log(row);
      this.dialogVisible = true;
      this.form=row;
    }
  },
  mounted() {
    this.getProductList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/ProductManager/index.vue